
export class ActionData {
    public action: string;
}